// ======================================================================
// FILE: src/modules/service_crm/services/installedProductService.js
// MODULE: Service CRM
// FEATURE: Installed Product API Service
//
// PURPOSE:
//   Frontend API client for Installed Product module
//
// BACKEND:
//   /api/service-crm/installed-products
// ======================================================================

import axiosClient from "../../../api/axiosClient";

/**
 * ----------------------------------------------------------------------
 * LIST INSTALLED PRODUCTS
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/service-crm/installed-products
 */
async function listInstalledProducts(params = {}) {

  const res = await axiosClient.get(
    "/api/service-crm/installed-products",
    { params }
  );

  const payload = res.data?.data || {};

  return {
    items: payload.data || [],
    pagination: payload.pagination || {},
  };
}

/**
 * ----------------------------------------------------------------------
 * GET INSTALLED PRODUCT
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/service-crm/installed-products/:id
 */
async function getInstalledProduct(productId) {

  const res = await axiosClient.get(
    `/api/service-crm/installed-products/${productId}`
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * CREATE INSTALLED PRODUCT
 * ----------------------------------------------------------------------
 * Backend:
 * POST /api/service-crm/installed-products
 */
async function createInstalledProduct(payload) {

  const res = await axiosClient.post(
    "/api/service-crm/installed-products",
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * UPDATE INSTALLED PRODUCT
 * ----------------------------------------------------------------------
 * Backend:
 * PUT /api/service-crm/installed-products/:id
 */
async function updateInstalledProduct(productId, payload) {

  const res = await axiosClient.put(
    `/api/service-crm/installed-products/${productId}`,
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * EXPORT
 * ----------------------------------------------------------------------
 */
const installedProductService = {

  listInstalledProducts,
  getInstalledProduct,
  createInstalledProduct,
  updateInstalledProduct,
};

export default installedProductService;